namespace RioERP.Web.Enums {
    export enum RioShieldVersion {
        Rioplay20 = 1,
        Rioplay2021 = 2,
        Other = 3
    }
    Serenity.Decorators.registerEnumType(RioShieldVersion, 'RioERP.Web.Enums.RioShieldVersion');
}
